//======================Huggler_promise

var sideMarginValue;

function adjustContainerWidth() {
  var screenWidth = $(window).width();
  var currentWidth = $(".container").width();
  sideMarginValue = (screenWidth - currentWidth) / 2;
  console.log("Calculated side margin:", sideMarginValue);
}

  // Call the function initially and on resize
  adjustContainerWidth();
  $(window).resize(function () {
    adjustContainerWidth();
  });
  
  let huggler_promise = new Swiper(".huggler_promise_slider", {
  slidesPerView: "auto",
  spaceBetween: 30,
  loop: false,
  breakpoints: {
      320: {
        slidesPerView: 1.2,
        centeredSlides: true,
        loop: true,
        spaceBetween: 24,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      576: {
        slidesPerView: 2.5,
        centeredSlides: true,
        loop: true,
        spaceBetween: 24,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      992: {
        slidesPerView: 3.5,
        centeredSlides: false,
        loop: false,
        slidesOffsetBefore: sideMarginValue,
        slidesOffsetAfter: sideMarginValue,
        spaceBetween: 24,
        scrollbar: {
          el: ".huggler_promise_wrapper .promise_scrollbar",
          hide: false,
          draggable: true,
        },
        navigation: {
          nextEl: ".huggler_promise_wrapper .swiper-button-next",
          prevEl: ".huggler_promise_wrapper .swiper-button-prev",
        },
      },
      1200: {
        slidesPerView: 4.3,
        spaceBetween: 24,
        slidesOffsetBefore: sideMarginValue,
        slidesOffsetAfter: sideMarginValue,
        scrollbar: {
          el: ".huggler_promise_wrapper .promise_scrollbar",
          hide: false,
          draggable: true,
        },
        navigation: {
          nextEl: ".huggler_promise_wrapper .swiper-button-next",
          prevEl: ".huggler_promise_wrapper .swiper-button-prev",
        },
      },
      1441: {
        slidesPerView: 4.8,
        spaceBetween: 24,
        slidesOffsetBefore: sideMarginValue,
        slidesOffsetAfter: sideMarginValue,
        scrollbar: {
          el: ".huggler_promise_wrapper .promise_scrollbar",
          hide: false,
          draggable: true,
        },
        navigation: {
          nextEl: ".huggler_promise_wrapper .swiper-button-next",
          prevEl: ".huggler_promise_wrapper .swiper-button-prev",
        },
      },
    },
  });

  // ===== same height ======

  function setEqualHeight() {
    let maxHeight = 0;

    // Find the maximum height
    document
      .querySelectorAll(".huggler_promise_inner_wrapper")
      .forEach((el) => {
        el.style.height = "auto"; // Reset height to auto to recalculate it properly
        const height = el.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
    document
      .querySelectorAll(".huggler_promise_inner_wrapper")
      .forEach((el) => {
        el.style.height = maxHeight + "px";
      });
  }
  setEqualHeight();
  window.addEventListener("resize", setEqualHeight);